// extracted by mini-css-extract-plugin
module.exports = {"languages":"style_languages__5gu2V","language":"style_language__1gTXQ"};